import Gravity from 'Gravity';

const insightsFiltersModule = () => {
  document.querySelectorAll('.gg-insights-filters').forEach((module) => {
    const showFiltersBtn = module.querySelector('.gg-insights-filters__show-filters-btn');
    const hideFiltersBtn = module.querySelector('.gg-insights-filters__hide-filters-btn');
    if(showFiltersBtn) {
      showFiltersBtn.addEventListener('click', () => {
        module.classList.add('filters-shown');
      });
    }
    if(hideFiltersBtn) {
      hideFiltersBtn.addEventListener('click', () => {
        module.classList.remove('filters-shown');
      });
    }
  });
};

Gravity.ready(insightsFiltersModule);
